var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 11,
    viewBox: "0 0 15 11",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 10.434783,
    rx: 1,
    width: 14.608696
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#094995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#074185"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5182f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc162c"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 1.391304h14.608696v7.652174h-14.608696z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h14.608696v1.391304h-14.608696z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 9.043478h14.608696v1.391304h-14.608696z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.304348,
    cy: 5.217391,
    fill: "url(#a)",
    mask: "url(#e)",
    r: 3.130435
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.30434783 7.65217391c-.19209906 0-.34782609-.15572702-.34782609-.34782608s.15572703-.34782609.34782609-.34782609c.19734191 0 .38974024-.03273802.57177426-.09607629.18143012-.06312815.37968375.03277453.44281189.21420464.06312814.18143012-.03277454.37968368-.21420466.44281182-.25529148.08882804-.52494727.134712-.80038149.134712zm1.84430824-.84517127c.17777523-.20610034.32014038-.44066696.42045558-.69421948.07067165-.17862685-.01684327-.38072326-.19547012-.45139497-.17862685-.0706717-.38072327.01684325-.45139499.1954701-.07156014.18087257-.1732455.34841347-.30035478.4957752-.12547054.14546195-.10926435.36509614.03619756.49056673.14546198.1254706.36509614.10926436.49056675-.03619758zm.56829252-1.9193595c-.03685169-.27181165-.11909489-.53327258-.2424601-.77515951-.08727722-.17112781-.2967559-.23910214-.46788376-.15182491-.17112779.08727722-.23910212.2967559-.1518249.46788371.08795645.17245959.14654094.35870661.17282337.5525609.02580828.19035748.20104529.32375094.39140278.29794262.1903575-.02580832.32375096-.20104532.29794261-.39140281zm-1.12103089-1.73455932c-.23046316-.14445427-.483856-.24954462-.75072013-.31011265-.18733468-.04251787-.373667.07487934-.41618484.262214s.07487937.37366694.26221398.4161848c.19017065.04316152.37076661.11806061.5352336.22114845.16276786.10202285.37742317.05277929.47944599-.10998858.10202288-.16276788.05277927-.37742317-.1099886-.47944602zm-1.94718532-.28109654c-.26325336.07345504-.51128656.19076934-.73458066.34629975-.15763041.10979387-.19640959.32658409-.08661571.48421451.10979387.15763042.32658409.19640959.4842145.08661572.15945184-.11106255.3363343-.19472409.52394646-.24707313.1850311-.05162884.29317496-.24347962.24154616-.42851072-.05162887-.18503109-.24347965-.29317498-.42851075-.24154613zm-1.53582523 1.28329648c-.11852677.24416792-.19559165.50715961-.22712097.77982174-.02206635.19082746.11474156.363412.30556901.38547835.19082746.02206635.36341199-.11474155.38547835-.30556901.02249524-.19453644.07739221-.38187787.16188798-.55594116.08388928-.17281387.01180165-.38091288-.16101222-.46480215-.17281386-.08388927-.38091288-.01180164-.46480215.16101223zm-.0413916 2.03432289c.10889877.24980271.25914686.47938105.44379425.67931718.13033163.14112306.3503891.14987123.49151213.01953957.14112304-.13033162.1498712-.3503891.01953958-.49151213-.13206598-.143001-.23943598-.30706182-.31715414-.4853394-.07676615-.17609373-.28174957-.25661466-.4578433-.17984852s-.25661466.28174957-.17984852.4578433zm1.49252081 1.34787885c-.1830206-.05835667-.28408069-.25403159-.22572403-.43705218.05835666-.18302061.25403161-.28408071.43705221-.22572404.15938905.05082167.32623226.07845783.49700207.08152546.19206803.0034502.34497301.16194912.34152278.35401716-.00345022.19206803-.16194908.344973-.35401711.34152278-.23848438-.00428397-.4722967-.04301301-.69583592-.11428918z",
    fill: "#118014",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBz);
export default __webpack_public_path__ + "static/media/BZ.13b0041793162a0486a428dd13f73472.svg";
export { ForwardRef as ReactComponent };